import React from 'react';
import styled from 'styled-components';
import TagManger from 'react-gtm-module';

import { generateBlueshyftCode } from '../../../../api/deposit';
import LoadingButton from '../../../../components/LoadingButton';
import { PaymentPages } from '../DepositService';
import { BlueshyftCode } from './BlueshyftCode';
import appConfig from '../../../../appConfig';

const BLUESHYFT_MAX_DEPOSIT = 8000;
const CashPaymentButtons = (props: Props) => {
	const { amount, updatePage, selectedPromotion, setError, setCode } = { ...props };

	const handleGenerateQRCode = async () => {
		try {
			let generatedQRCode;
			if (selectedPromotion?.id) generatedQRCode = await generateBlueshyftCode(amount, selectedPromotion);
			else generatedQRCode = await generateBlueshyftCode(amount);
			if (appConfig.googleTagManagerID)
				TagManger.dataLayer({
					dataLayer: {
						event: 'deposit',
						deposit_amount: amount,
						deposit_method: 'Blueshyft Code Generation',
					},
				});
			setCode(generatedQRCode);
			updatePage(PaymentPages.Cash);
		} catch (e: any) {
			// catches must have any or unknown objects
			if (e.errors.error) setError(`Error generating Blueshyft Code: ${e.errors.error[0]}`);
			else setError('Error generating blueshyft code');
		}
	};

	React.useEffect(() => {
		// if amount is decimal
		if (amount > 0 || !isNaN(amount)) {
			if (amount % 1 !== 0) {
				setError('Cash deposit can only be whole dollars');
			}
			if (amount > BLUESHYFT_MAX_DEPOSIT) {
				setError('Cash deposit cannot exceed $' + BLUESHYFT_MAX_DEPOSIT);
			}
		}
	}, [amount]);

	return (
		<ButtonsWrapper>
			<LoadingButton
				className="_w-full _mt-4 _btn _btn-primary _rounded"
				disabled={amount <= 0 || isNaN(amount) || amount > BLUESHYFT_MAX_DEPOSIT || amount % 1 !== 0}
				onClick={handleGenerateQRCode}
			>
				Generate QR Code
			</LoadingButton>
			<LoadingButton
				className="_w-full _mt-4 _btn _btn-primary-action _rounded"
				onClick={() => {
					updatePage(PaymentPages.Map);
				}}
			>
				Find a Store
			</LoadingButton>
		</ButtonsWrapper>
	);
};

export default CashPaymentButtons;

interface Props {
	amount: number;
	updatePage: (id: number) => void;
	selectedPromotion?: { id: string; client_id: number };
	setError: (error: string) => void;
	setCode: (code: BlueshyftCode) => void;
}

const ButtonsWrapper = styled.div`
	display: flex;
	> button {
		margin-left: 4px;
		margin-right: 4px;
	}
	justify-content: center;
`;
